import {Injectable} from '@angular/core';
import {DocumentModel} from "../model/document.model";
import {DocumentSummaryModel} from "../model/documentSummary.model";
import {DocumentRepository} from "../../impl/service/ngrx/document.repository";
import {DocumentSummaryDataServiceAdapter} from "../../impl/service/ngrx/documentSummaryDataService.adapter";
import {AbstractFindOneByIdService} from "../../../../core/service/v2/service/findone/abstractFindOneById.service";

@Injectable()
export class DocumentSummaryFindOneByIdService extends AbstractFindOneByIdService<DocumentModel, DocumentSummaryModel>{
    constructor(repository: DocumentRepository, dataServiceAdapter: DocumentSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

}
